import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { AddVendorAdjustmentTripsComponent } from './add-vendor-adjustment-trips/add-vendor-adjustment-trips.component';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-adjustment-trips-vendor',
  templateUrl: './adjustment-trips-vendor.component.html',
  styleUrls: ['./adjustment-trips-vendor.component.scss']
})
export class AdjustmentTripsVendorComponent {

  public _mFormGroup: FormGroup;
  public mLocation = new FormControl("", Validators.required);
  public mSite = new FormControl("", Validators.required);
  public mFromDate = new FormControl('');
  public mToDate = new FormControl("", Validators.required);
  public mstatus = new FormControl("", Validators.required);

  _mColumns: any[] = [];
  _mData: any[] = [];
  firstStep: boolean = false;
  secondStep: boolean = false;
  _mCurrentUserData: any;
  dataSource = new MatTableDataSource<any>(this._mData);
  displayedColumns = ['date', 'tripCode', 'siteName', 'vendorName', 'employeeId', 'reason', 'logType', 'nearestShiftTime', 'approximateKm', 'escortRequired', 'vehicleType', 'vehicleNo', 'driverName', 'status'];
  statusData = [{ status: 'ALL' }, { status: 'SENT_FOR_ADMIN_APPROVAL' }, { status: 'Approved' }, { status: 'Rejected' }]
  cities: any;
  _mSitesData: any;
  minDate: any;
  maxDate: any;
  tableFlag: boolean;
  page: number = 1;
  size: number = 20;
  _mCurrentNumber: number = 0;
  _mTotalElements: number = 0;
  _mNumberOfElements: number = 0;
  _mTotalPage: number = 1;
  itemsPerPage = 0;
  activeTabId = 1;

  constructor(
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    public readonly serviceLocalStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService,
    private fb: FormBuilder,
    public readonly dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this._mCurrentUserData = this.serviceLocalStorage.getUserObject();
    this.loadCities();
    this._mFormGroup = this.fb.group({
      location: this.mLocation,
      site: this.mSite,
      fromDate: this.mFromDate,
      toDate: this.mToDate,
      status: this.mstatus
    });
  }

  loadCities() {
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getserchlocationlist,
      success => {
        if (success.status == 200) {
          this.cities = success.body || [];

          const userLocationId =
            this._mCurrentUserData?.userInfoDetails?.site?.location?.locationId;

          const selectedLocationId =
            this.cities.find(c => c.locationId === userLocationId || c.id === userLocationId)
              ? userLocationId
              : (this.cities[0]?.locationId || this.cities[0]?.id);

          if (selectedLocationId) {
            this.mLocation.setValue(selectedLocationId);
            this.getSitesByCityId();
          }

        } else {
          this.cities = [];
        }
      },
      error => {
        this.notifyService.showError(error, null);
      }
    );
  }

  getSitesByCityId() {
    this.mSite.setValue('');

    this.apiService.doGetRequestWithResponse(
      ApiConstants.getserchsitelist + this.mLocation.value,
      success => {
        if (success.status == 200) {
          this._mSitesData = success.body || [];

          const userSiteId =
            this._mCurrentUserData?.userInfoDetails?.site?.siteId;

          const selectedSiteId =
            this._mSitesData.find(s => s.siteId === userSiteId)
              ? userSiteId
              : this._mSitesData[0]?.siteId;

          if (selectedSiteId) {
            this.mSite.setValue(selectedSiteId);
          }

          if (!this.mstatus.value) {
            this.mstatus.setValue(
              this.statusData?.length ? this.statusData[0].status : 'ALL'
            );
          }
          if (!this.mFromDate.value) {
            this.mFromDate.setValue(new Date() as any);
          }
          if (!this.mToDate.value) {
            this.mToDate.setValue(new Date() as any);
          }

        } else {
          this._mSitesData = [];
          this.notifyService.showInfo('No Sites Found!', null);
        }
      },
      error => {
      }
    );
  }

  dateChanged(data) {
    this.mToDate.setValue("");
    this.minDate = data.value;
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return d.getFullYear() + "-" + mm + "-" + dt;
  }

  onSubmit() {
    if (!this._mFormGroup.valid) return;
    this.ngxLoader.start();
    const endpoint = `${ApiConstants.getAdjustmentTrip}${this.mSite.value}&fromDate=${this.formatDate(this.mFromDate.value)}&toDate=${this.formatDate(this.mToDate.value)}&status=${this.mstatus.value}&page=${this.page - 1}&size=${this.size}`;
    this.apiService.doGetRequestWithResponse(endpoint, success => {
      this.ngxLoader.stop();
      this.tableFlag = true;
      if (success.status !== 200 || !success.body.data.length) {
        this.resetTableData();
        // this.notifyService.showInfo("No data found", null);
        return;
      }

      this._mData = this.dataSource.data = success.body.data.map(element => ({
        id: element.id,
        date: element.date,
        tripCode: element.tripCode,
        siteName: element.siteName,
        vendorName: element.vendorName,
        employeeId: element.employeeId,
        reason: element.reason,
        logType: element.logType,
        nearestShiftTime: element.nearestShiftTime,
        approximateKm: element.approximateKm,
        escortRequired: element.escortRequired,
        vehicleType: element.vehicleType,
        vehicleNo: element.vehicleNo,
        driverName: element.driverName,
        status: element.status
      }));

      this._mCurrentNumber = success.body.pageNo;
      this._mTotalPage = success.body.totalPages;
      this.size = success.body.size;
      this._mTotalElements = success.body.totalElements;
      this._mNumberOfElements = success.body.noOfElements;
    }, () => this.ngxLoader.stop());
  }

  resetTableData() {
    this._mData = [];
    this.dataSource.data = [];
    this._mCurrentNumber = 0;
    this._mTotalElements = 0;
    this._mTotalPage = 0;
    this._mNumberOfElements = 0;
    this.size = 0;
  }

  onNewPageRequest($event) {
    if ($event !== null || $event !== undefined) {
      this.page = $event;
      this.onSubmit();
    }
  }

  openDialog(userEdit): void {
    // const roleId = this._mCurrentUserData.userInfoDetails.role.id;
    // let data = null;
    // if (roleId === 3) {
    //   data = { employeeAccessFlag: true, userData: this._mCurrentUserData };
    // } else if (roleId === 4) {
    //   data = { employeeAccessFlag: true, userData: null };
    // } else if ((roleId === 1 || roleId === 2) && userEdit) {
    //   data = { employeeAccessFlag: false, userData: userEdit };
    // }

    const dialogRef = this.dialog.open(AddVendorAdjustmentTripsComponent, {
      width: '750px',
      disableClose: true,
      // data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this._mFormGroup.valid) {
        this.onSubmit();
      }
      // else if (result) {
      //   this.notifyService.showWarning("Please fill all required fields", null);
      // }
    });
  }

}

